<template>
    <div class="addCategoriesComponent">
        <div v-if="loading" class="text-center">
            <v-progress-circular
                class="mt-auto"
                :size="70"
                :width="7"
                color="primary"
                indeterminate
            ></v-progress-circular>
        </div>
        <div v-else class="row">
            <div class="col-md-7">
                <v-form 
                    ref="form" 
                    lazy-validation 
                    class="mt-5 col-sm-8 col-md-8"
                    >
                    <v-text-field
                        :label="$t('marketplace.label.mode.title')"
                        color="secondary"
                        v-model=formData.nombreModo
                        readonly
                        disabled
                    ></v-text-field>

                    <v-select
                        :label="'*'+$t('marketplace.label.categoryBenefit.title')" 
                        :placeholder="$t('marketplace.label.categoryBenefit.text')" 
                        color="secondary"
                        required
                        :items="categoriasBeneficios"
                        item-text="descripcion"
                        item-value="idCategoriaBeneficio"
                        :rules="categoryBenefitRules"
                        v-model="formData.idCategoriaBeneficio"
                    ></v-select>

                    <v-select
                        :label="'*'+$t('marketplace.label.typeCategory.title')" 
                        :placeholder="$t('marketplace.label.typeCategory.text')" 
                        color="secondary"
                        required
                        :items="tipoCategoriaMarketplace"
                        item-text="nombre"
                        item-value="idTipoCategoriaComercial"
                        :rules="typeRules"
                        v-model="formData.idTipoCategoriaComercial"
                    ></v-select>

                    <v-text-field
                        :label="'*'+$t('marketplace.label.nameCategory.title')" 
                        :placeholder="$t('marketplace.label.nameCategory.text')" 
                        color=secondary
                        required
                        :counter="25"
                        :maxlength="25"
                        :rules="nameRules"
                        v-model="formData.nombre"
                    ></v-text-field>

                    <v-text-field
                        :label="'*'+$t('marketplace.label.description.title')" 
                        :placeholder="$t('marketplace.label.description.text')" 
                        color=secondary
                        :counter="40" 
                        :maxlength="40"
                        required
                        :rules="descriptionRules"
                        v-model="formData.descripcion"
                    ></v-text-field>

                    <v-text-field
                        :label="'*'+$t('marketplace.label.responsible.title')" 
                        :placeholder="$t('marketplace.label.responsible.text')" 
                        color=secondary
                        required
                        :counter="40" 
                        :maxlength="40"
                        :rules="responsibleRules"
                        v-model="formData.responsable"
                    ></v-text-field>

                    <v-text-field
                        :label="'*'+$t('label.phone.title')" 
                        :placeholder="$t('label.phone.text')" 
                        color="secondary"
                        required
                        :rules="phoneRules"
                        v-model="formData.telefono"
                        @keydown="handleKeyDown"
                        inputmode="numeric"
                        pattern="[0-9]{0,15}"
                        :counter="15"
                        :maxlength="15"
                    ></v-text-field>

                    <v-text-field
                        :label="'*'+$t('label.email.title')" 
                        :placeholder="$t('label.email.text')" 
                        color=secondary
                        required
                        :rules="mailRules"
                        :counter="200" 
                        :maxlength="200"
                        v-model="formData.correo"
                    ></v-text-field>
                </v-form>

                <div class="img-btn">
                    <div>
                        <changeImage/>
                    </div>

                    <v-tooltip left>

                        <template v-slot:activator="{ on, attrs }">

                            <v-btn
                                fab
                                fixed
                                bottom
                                right
                                dark
                                large
                                color="primary"
                                v-bind="attrs"
                                v-on="on"
                                @click="submitForm"
                                >
                                <v-icon dark>mdi-content-save</v-icon>
                            </v-btn>

                        </template>

                        <span>{{ $t('button.save') }}</span>

                    </v-tooltip>  
                </div>

            </div>
        </div>
    </div>
</template>

<script>

    import  EventBus  from '@/utils/event_bus.js'; 
    import { mapActions, mapGetters } from "vuex";
    import changeImage from "@/shared/components/icons_selector/change_image_component.vue";
    import {
        MARKETPLACE_M,
        GET_CATEGORIES_BENEFITS_MARKETPLACE,
        GET_CATEGORY_TYPE_MARKETPLACE,
        GET_STATE_LOADING_MARKETPLACE,
        GET_MODO_MARKETPLACE,
        ACTION_GET_MODE_MARKETPLACE,
        ACTION_GET_CATEGORIES_BENEFITS_MARKETPLACE,
        ACTION_GET_CATEGORY_TYPE_MARKETPLACE,
        ACTION_POST_CREATE_CATEGORIES_MARKETPLACE,
    }from "@/views/categories_marketplace/store/types/types.js";
    import i18n from '@/plugins/i18n';
    import Swal from "sweetalert2";
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
    export default {

        components: {
            changeImage
        },
        name:"addCategoriesComponent",
       
        data() {
            return {
                formData: {
                    idCategoriaBeneficio: null,
                    nombreModo: null,
                    idImagenCategoria:null,
                    idTipoCategoriaComercial: '',
                    nombre: '',
                    descripcion: '',
                    responsable: '',
                    telefono: '',
                    correo: '',
                    idModo: null,
                },
                
                categoryBenefitRules: [
                    v => !!v || this.$t('marketplace.label.categoryBenefit.required')
                ],
                typeRules: [
                    v => !!v || this.$t('marketplace.label.typeCategory.required')
                ],
                nameRules: [
                    v => !!v  || this.$t('marketplace.label.nameCategory.required')
                ],
                descriptionRules: [
                    v => !!v || this.$t('marketplace.label.description.required')
                ],
                responsibleRules: [
                    v => !!v || this.$t('marketplace.label.responsible.required')
                ],
                phoneRules: [
                    v => !!v || this.$t('label.phone.required'),
                    v => (v && v.length >= 7 && v.length <= 15) || this.$t('label.phone.maxLength')
                ],
                mailRules: [
                    v => !!v || this.$t('label.email.required'),
                    v => emailRegex.test(v) || this.$t('label.email.invalid')
                ],
                categoriaBeneficioList:[],
                categoriasBeneficios:[],
                tipoCategoriaMarketplace:[],
                showErrorMessages: false,
                emailRegex: /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/
            };
        },
        
        async mounted() {

            // id del modo
            await this.getMode();
            const modos = await this.modes
            const id = modos[0].idModoCategoria;

            // lista categorias beneficios
            this.categoriaBeneficioList = await this.getCategoriaBeneficioMarketplace(id);
            this.categoriasBeneficios = this.categoriaBeneficioList.payload;

            if (this.categoriaBeneficioList.payload) {

                //this.formData.idCategoriaBeneficio = this.categoriaBeneficioList.payload[0].idCategoriaBeneficio;

                this.formData.idModo = this.modos[0].idModoCategoria;
                this.formData.nombreModo = this.modos[0].nombre;
            }
            
            // lista de los tipos de categorias
            this.tipoCategoriaMarketplace = await this.getTipoCategoria(id);

            // Escucha el evento emitido por el componente hijo
            EventBus.$on('icon-selected', (iconId) => {

                this.formData.idImagenCategoria = iconId;

            });

            // Escuchar evento para limpiar el formulario cuando el diálogo se cierra
            EventBus.$on('clear-categories-marketplace-form', this.clearForm);
        },
        
        beforeDestroy() {
            // Limpiar el event listener
            EventBus.$off('clear-categories-marketplace-form', this.clearForm);
        },
        methods: {

            async getTipoCategoria(id) {
                const response = await this.getTipoCategoriaMarketplace(id);
                return response;
            },

            clearForm() {
                this.formData = {
                    idTipoCategoriaComercial: '',
                    idCategoriaBeneficio: '',
                    nombre: '',
                    descripcion: '',
                    responsable: '',
                    telefono: '',
                    correo: ''
                }

                // Resetear validación del formulario
                if (this.$refs.form) {
                    this.$refs.form.reset();
                }
                EventBus.$emit('clear-icon');
            },

            handleKeyDown(event) {
                // Permite solo números y la tecla de borrar
                if (!/^[0-9]$/.test(event.key) && event.key !== 'Backspace') {
                    event.preventDefault();
                }
            },

            ...mapActions({
                getMode: `${MARKETPLACE_M}${ACTION_GET_MODE_MARKETPLACE}`,
                getCategoriaBeneficioMarketplace: `${MARKETPLACE_M}${ACTION_GET_CATEGORIES_BENEFITS_MARKETPLACE}`,
                getTipoCategoriaMarketplace: `${MARKETPLACE_M}${ACTION_GET_CATEGORY_TYPE_MARKETPLACE}`,
                postCrearCategoria: `${MARKETPLACE_M}${ACTION_POST_CREATE_CATEGORIES_MARKETPLACE}`,
            }),

            async submitForm() {
                // Validar el formulario antes de enviarlo
                const validationErrors = this.validateForm();

                // Si hay errores de validación, mostrarlos en un único Swal y no enviar el formulario
                if (Object.keys(validationErrors).length > 0) {
                    const errorMessages = Object.values(validationErrors).join('<br>');
                    Swal.fire({
                        icon: 'error',
                        title: i18n.t('label.errorsValidation.plural.title'),
                        html: '<div class="swal-subtitle"><b>'+ i18n.t('label.errorsValidation.text') +':</b></div><br>' + errorMessages,
                        confirmButtonColor: '#6E17A5'
                    });
                    return;
                }

                // Si no hay errores de validación, imprime el formulario en la consola
                const save = this.postCrearCategoria(this.formData);
                if(!save){

                    return Swal.fire({
                        icon: 'error',
                        title: i18n.t('label.invalid.title'),
                        text: i18n.t('label.invalid.text')
                    })

                }

                await this.clearForm();
                EventBus.$emit('formMarketplace-submitted-successfully');
                
            },

            validateForm() {
                this.showErrorMessages = true;

                // Expresión regular para validar que no consista solo en espacios en blanco o tabulaciones
                const notOnlyWhitespaceRegex = /\S/;

                const errors = {};

                if (!this.formData.idCategoriaBeneficio) {
                    errors.idCategoriaBeneficio = this.$t('marketplace.label.categoryBenefit.title');
                }

                if (!this.formData.idTipoCategoriaComercial) {
                    errors.idTipoCategoriaComercial = this.$t('marketplace.label.typeCategory.title');
                }

                if (!this.formData.nombre || !this.formData.nombre.trim() || this.formData.nombre.length > 25) {
                    errors.nombre = this.$t('marketplace.label.nameCategory.title');
                }

                if (!this.formData.descripcion || !this.formData.descripcion.trim() || this.formData.descripcion.length > 40) {
                    errors.descripcion = this.$t('marketplace.label.description.title');
                }

                if (!this.formData.responsable || !notOnlyWhitespaceRegex.test(this.formData.responsable) || this.formData.responsable.length > 40) {
                    errors.responsable = this.$t('marketplace.label.responsible.title');
                }

                if (!this.formData.telefono || !/^[0-9]{7,15}$/.test(this.formData.telefono)) {
                    errors.telefono = this.$t('label.phone.title');
                }

                if (!this.formData.correo || !emailRegex.test(this.formData.correo) || this.formData.correo.length > 50) {
                    errors.correo = this.$t('label.email.title');
                }

                if (!this.formData.idImagenCategoria) {
                    errors.idImagenCategoria = this.$t('marketplace.label.imageCategory');
                }

                return errors;
            },

        },
    
        computed: {

            ...mapGetters({
                modes: `${MARKETPLACE_M}${GET_MODO_MARKETPLACE}`,
                categorias_beneficios: [`${MARKETPLACE_M}${GET_CATEGORIES_BENEFITS_MARKETPLACE}`], 
                tipo_categorias: [`${MARKETPLACE_M}${GET_CATEGORY_TYPE_MARKETPLACE}`],
                loading: `${MARKETPLACE_M}${GET_STATE_LOADING_MARKETPLACE}`,
                modos: `${MARKETPLACE_M}${GET_MODO_MARKETPLACE}`,
            }),

        },

    };

</script>


<style lang="css" scoped>

    /* Css input imagen*/

    .col-md-7 {
        display: flex;
        justify-content: center;
        align-items: center;
        gap:230px;
    }

    .row {
        display: flex;
        justify-content: center;
    }

    /*Resposive*/

    @media screen and (max-width: 912px) {
        .col-md-7 {
            gap:40px;
        }
    }
    @media screen and (max-width: 820px) {
        .col-md-7 {
            gap:40px;
        }
    }

    @media screen and (max-width: 768px) {
        .col-md-7 {
            gap:40px;
        }
    }
    @media screen and (max-width: 425px) {
        .col-md-7 {
            gap:10px;
            display: flex;
            flex-direction: column-reverse;
        } 
    }

</style>